<script lang="ts">
import { PropType, VNode, defineComponent, h, resolveComponent } from 'vue';

import { ITableOptions } from '@/bundles/BaseTable/interfaces';

interface IProps {
  totalRowsEntry: number;
  items: any[];
  tableOptions: ITableOptions;
  filterLoading: boolean;
}

export default defineComponent({
  name: 'DashboardMobileTable',

  inheritAttrs: false,

  props: {
    items: {
      type: Array as PropType<any[]>,
      required: true
    },
    tableOptions: {
      type: Object as PropType<ITableOptions>,
      required: true
    },
    filterLoading: Boolean,
    totalRowsEntry: {
      type: Number,
      required: true
    },
  },

  render (): VNode | VNode[] {
    const props = this.$props as IProps;
    const VDataTable = resolveComponent('v-data-table');

    return h(VDataTable, {
      ...this.$attrs,
      items: props.items,
      itemsPerPage: props.tableOptions.itemsPerPage,
      mobileBreakpoint: 0,
      page: props.tableOptions.page,
      loading: props.filterLoading,
      hideDefaultHeader: true,
      serverItemsLength: props.totalRowsEntry,
      class: ['dashboard-table', this.$attrs.class],
      'onUpdate:page': (page: number) => (this.$attrs['onUpdate:tableOptions'] as Function)({ ...props.tableOptions, page }),
      'onUpdate:items-per-page': (itemsPerPage: number) => (this.$attrs['onUpdate:tableOptions'] as Function)({ ...props.tableOptions, itemsPerPage }),
    }, {
      item: ({ item, index }: { item: any, index: number }) => this.$slots.item ? this.$slots.item({ item, index }) : null,
    });
  }
})
</script>
